<div class="c__content">
  @if (!isLoading) {
    <sd-title [titleLevel]="titleLevel" [customClass]="'brand--h2 is-text-' + titleThemeConfig">
      {{title}}
    </sd-title>
  }

  <ng-content />

  @if (links && !isLoading) {
    <div class="c__actions-app">
      @for (link of links; track link) {
        <sd-link
          [customClass]="link?.media ? 'is-reset' : '' "
          [isButton]="link?.media ? false : true"
          [link]="link"
          (clicked)="clicked(link)"
        >
          @if (link?.media) {
            <sd-banner
              [media]="link?.media"
              [isFit]="true"
              (mediaPlay)="onMediaPlay(link?.media, title)"
            />
          }
          <span class="{{link?.media ? 'is-visually-hidden' : ''}}">
            {{ link?.linkName }}
          </span>
        </sd-link>
      }
    </div>
  }
</div>

@if (mediaTop || mediaBottom) {
  <div class="c__media-wrapper">
    @if (mediaTop) {
      <sd-banner
        [isComponentLoading]="isLoading"
        [media]="mediaTop"
        [imgRatio]="ratioMediaTop"
        [hasModal]="true"
        [hasAltText]="false"
        [twicPicsAutoSize]="twicPicsAutoSize"
        (mediaPlay)="onMediaPlay(mediaTop, title)"
      />
    }
    @if (mediaBottom) {
      <sd-banner
        [isComponentLoading]="isLoading"
        [media]="mediaBottom"
        [imgRatio]="ratioMediaBottom"
        [hasModal]="false"
        [hasAltText]="false"
        [twicPicsAutoSize]="twicPicsAutoSize"
        (mediaPlay)="onMediaPlay(mediaBottom, title)"
      />
    }
  </div>
}
